import { initGraphQLTada } from "gql.tada";
import type { introspection } from "@/types/graphql-env.d.ts";

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    DateTime: string;
    Decimal: number;
    Time: string;
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from "gql.tada";

//export { readFragment } from "gql.tada"; <knip: Unused item in ignoreDependencies>
